// extracted by mini-css-extract-plugin
export default {"container":"TagFormField_container__noQN7","tags":"TagFormField_tags__geSmf"};